import { BRANCH_GROUP_TYPE, CLANDESTINE_GROUP_TYPE, CLANDESTINE_GROUP_TYPE_NAME, COMPANY_WALL_GROUP_TYPE, PRIVATE_GROUP_TYPE, PRIVATE_GROUP_TYPE_NAME, WORK_GROUP_TYPE, WORK_GROUP_TYPE_NAME } from '../const/const';
import moment from "moment";
export const helpers = {
    getGroupTypeNameAndColor: (type) => {
        let groupData = {};
        switch (type) {
            case WORK_GROUP_TYPE:
                groupData.typeName = WORK_GROUP_TYPE_NAME;
                groupData.classColor = 'work-group-name-color';
                break;
            case COMPANY_WALL_GROUP_TYPE:
            case BRANCH_GROUP_TYPE:
            case PRIVATE_GROUP_TYPE:
                groupData.typeName = PRIVATE_GROUP_TYPE_NAME;
                groupData.classColor = 'private-group-name-color';
                break;
            case CLANDESTINE_GROUP_TYPE:
                groupData.typeName = CLANDESTINE_GROUP_TYPE_NAME;
                groupData.classColor = 'clandestine-group-name-color';
                break;
        }
        return groupData;
    },
    fromNow(date) {
        return moment(date).locale("vi").fromNow();
    },
    createSlug(str) {
        str = helpers.convertViToEn(str);
        str = str.trim().toLowerCase();
        str = str.replace('/[^a-z0-9-]/', '-');
        str = str.replace('/-+/', "_");
        return str;
    },
    convertViToEn(str, checkNumber = false) {
        str = str.replace(" ", "_");
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        str = str.replace(/đ/g, "d");
        str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
        str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
        str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
        str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
        str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
        str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
        str = str.replace(/Đ/g, "D");
        if (checkNumber) {
            str = str.replace(/0/g, "");
            str = str.replace(/1/g, "");
            str = str.replace(/2/g, "");
            str = str.replace(/3/g, "");
            str = str.replace(/4/g, "");
            str = str.replace(/5/g, "");
            str = str.replace(/6/g, "");
            str = str.replace(/7/g, "");
            str = str.replace(/8/g, "");
            str = str.replace(/9/g, "");
        }
        return str;
    },
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    isEmpty(text) {
        if (text) {
            if (text !== '') {
                return false;
            }
        }
        return true;
    },
    goToProfile(userId) {
        window.open('/profile/' + userId, '_blank');
    },
    getMessageTime(item) {
        return moment(item.created_at).format('HH:mm');
    },
    checkMessageInBlock(currentMess, nextMess) {
        if (nextMess == null)
            return false;
        const senderNext = nextMess.sender;
        if (senderNext && senderNext.id !== currentMess.sender.id)
            return false;
        const current = moment(currentMess.created_at);
        const next = moment(nextMess.created_at);
        const offset = next.diff(current, 'minutes');
        return offset < 2;
    },
    checkShowSenderName(currentMess, prevMess) {
        if (prevMess == null)
            return true;
        const self = helpers;
        if (currentMess.sender.id !== self.user?.id) {
            return currentMess.sender.id !== prevMess.sender.id || helpers.checkShowTime(currentMess, prevMess);
        }
        return false;
    },
    checkShowTime(currentMess, prevMess) {
        if (prevMess == null) {
            const self = helpers;
            const anchor = self.prevMess;
            if (!anchor)
                return true;
            return !moment(currentMess.created_at).isSame(moment(anchor.created_at), "days");
        }
        return true;
    },
    sumEmoji(emojiList) {
        return Object.keys(emojiList).reduce(function (previous, key) {
            return previous + emojiList[key];
        }, 0);
    },
    bytesToSize(bytes) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0)
            return '0 Byte';
        var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
        return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
    },
    normalizeFileExtension(extension) {
        return String(extension || '').toLowerCase().replace(/^\./, '');
    },
    buildMediaViewUrl(downloadUrl) {
        if (!downloadUrl) {
            return null;
        }
        if (downloadUrl.includes('/download/')) {
            return downloadUrl.replace('/download/', '/view/');
        }
        return null;
    },
    canViewChatFile(file) {
        const ext = helpers.normalizeFileExtension(file?.extension);
        const inlineTypes = ['pdf', 'png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'txt', 'csv'];
        const officeTypes = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
        return inlineTypes.includes(ext) || officeTypes.includes(ext);
    },
    buildChatFileViewUrl(file) {
        if (!file || !helpers.canViewChatFile(file)) {
            return null;
        }
        const ext = helpers.normalizeFileExtension(file.extension);
        const officeTypes = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
        const viewUrl = helpers.buildMediaViewUrl(file.url) || file.path || file.url || null;
        if (!viewUrl) {
            return null;
        }
        if (officeTypes.includes(ext)) {
            return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(viewUrl)}`;
        }
        if (ext === 'pdf' && file.path) {
            return file.path;
        }
        return viewUrl;
    },
    getFileType(type) {
        const ext = helpers.normalizeFileExtension(type);
        if (['xlsx', 'xls', 'csv'].includes(ext)) {
            return '/img/chat/icon-excel.svg';
        }
        if (['docx', 'doc', 'txt', 'rtf'].includes(ext)) {
            return '/img/chat/icon-word.svg';
        }
        if (['pdf'].includes(ext)) {
            return '/img/chat/icon-pdf.svg';
        }
        if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'img', 'svg'].includes(ext)) {
            return '/img/chat/icon-photo.svg';
        }
        if (['mp4', 'mov', 'avi', 'mkv', 'webm', 'video'].includes(ext)) {
            return '/img/chat/icon-video.svg';
        }
        return '/img/chat/icon-file-empty.svg';
    },
};
